// removed by extract-text-webpack-plugin
module.exports = {"navbar":"src-scripts-components-views-BackendView-__backendView___navbar","leftGroup":"src-scripts-components-views-BackendView-__backendView___leftGroup","rightGroup":"src-scripts-components-views-BackendView-__backendView___rightGroup","centerGroup":"src-scripts-components-views-BackendView-__backendView___centerGroup","viewport":"src-scripts-components-views-BackendView-__backendView___viewport","content":"src-scripts-components-views-BackendView-__backendView___content","contentCard":"src-scripts-components-views-BackendView-__backendView___contentCard"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/views/BackendView/backendView.css
// module id = 2795
// module chunks = 0